import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { Location, LocationDialogData, LocationDialogResult } from '@core/interfaces';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { LocationService } from '../../services/location.service';
import { DialogLocationsComponent } from './dialog-locations.component';

@Injectable({
  providedIn: 'root'
})
export class DialogLocationService {
  constructor(
    private readonly matDialog: MatDialog,
    private readonly locationService: LocationService,
    private readonly authenticationService: AuthenticationService,
    private readonly fuseProgressBarService: FuseProgressBarService,
  ) {}

  public async open({ locationId }: { locationId?: string }): Promise<LocationDialogResult> {
    const location = await this.getLocation({ locationId });
    return this.matDialog.open<DialogLocationsComponent, LocationDialogData, LocationDialogResult>(DialogLocationsComponent, {
      panelClass: ['dialog-locations'],
      autoFocus: false,
      data: {
        location,
        isViewMode: !this.authenticationService.hasPermission('locations-edit'),
      }
    }).afterClosed()
      .toPromise();
  }

  public async getLocation({ locationId }: { locationId: string }): Promise<Location> {
    this.fuseProgressBarService.show();
    const result = locationId ? await this.locationService.getLocationById(locationId) : null;
    this.fuseProgressBarService.hide();

    return result;
  }
}
